/*
 *  ih.preload
 *
 * Preload images that will be used later by the page.
 * Eventually we might extend this to support other types of resources like js.
 *
 *
 * Depends:
 *      jQuery
 *
 * Usage:
 *
 * preload a single image by using it's source as a single string parameter
 *
 * ih.preload("/my-image.jpg");
 *
 *
 * or preload multiple images by passing in an array of strings.
 *
 * ih.preload(["/my-image.jpg", "/my-image2.gif"]);
 *
 *
 * the callback function fires after all images are loaded
 *
 * ih.preload("/my-image.png", function(src) {
 *      console.log(src + " is preloaded now");
 * });
 * ih.preload(["/my-image1.png", "/my-image2.png"], function(src_arr) {
 *      console.log("preloaded images:", src_arr);
 * });
 *
 *
 */
(function($) {
//    console.log("loading ih.preload class definition");

    ih = ih || {};

    ih.preload = ih.preload || function(src, callback) {

        var _this = this; // class instance
        var _count = 1;
        var _preload_count = 0;
        var _src = ih.staticurl(src);

        // handle the preload for a single image
        var _preload = function( src ) {
            $("<img />").on("load", function() {

                // do we need to add it to the DOM?
                // supposedly this is needed to cache the image between pages

                _preload_count++;

                // fire callback when all images are done preloading
                if ( _preload_count == _count ) {
                    if ( callback && $.isFunction(callback) ) {
                        callback( _src );
                    }
                }
            })
            .attr("src", src);
        };

        // single src
        if ( typeof src == 'string' ) {
            _preload( ih.staticurl(src) );
        }
        // else an array of srcs
        else if ( $.isArray( src ) ) {
            _count = src.length;
            $.each(src, function(index) {
                _preload( ih.staticurl(this) );
            });
        }
        else {
            throw new Error("The src must be a string value or an array of strings");
        }
    }

})(jQuery);
